module.exports = __webpack_public_path__ + "static/img/mechanism-4.d6025541.png";